import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { UpdateNetworkModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/customers-service-lib/src/wrapper/inputs/networks/update-network.model';
import { SubmitErrorHandler } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { NetworkUpdateFormStep1Controller } from '@app/feature/network/network-update/network-update-form-step-1/network-update-form-step-1.controller';
import { useUpdateNetworkContext } from '@app/feature/network/network.context';

interface NetworkUpdateFormControllerProps {
  onError: SubmitErrorHandler<
    Pick<UpdateNetworkModel, 'network' | 'networkId'>
  >;
  onSubmit: SubmitHandlerWithDirtyFields<
    Pick<UpdateNetworkModel, 'network' | 'networkId'>
  >;
  onCancel: () => void;
  state: MultiStepFormState;
}

export const NetworkUpdateFormController = (
  props: NetworkUpdateFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel, state } = props;
  const { t } = useTranslation();
  const data = useUpdateNetworkContext();

  return (
    <MultiStepFormProvider<Pick<UpdateNetworkModel, 'network' | 'networkId'>>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      state={state}
      items={[
        {
          title: t('$.network-update.step-1.title'),
          iconName: 'server-06',
          fields: [
            'network.name',
            'network.description',
            'network.holder.firstName',
            'network.holder.lastName',
            'network.holder.email',
            'network.holder.address.address',
            'network.holder.address.city',
            'network.holder.address.countryCode',
            'network.holder.address.zipCode',
            'network.holder.companyName',
            'network.holder.siret',
            'network.holder.vatNumber',
            'network.billingDetails.mandate.documentNumber',
            'network.billingDetails.mandate.dateOfSignature',
            'network.billingDetails.bic',
            'network.billingDetails.iban',
          ],
          component: <NetworkUpdateFormStep1Controller />,
        },
      ]}
    />
  );
};
